import { Formik } from "formik"
import { Button, Form, Col, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { axiosPrivate } from "../../../../api/axios"

import { RoutePaths } from "../../../../routes/RoutePaths"
import FormikSelect, {
  TSelectFieldOptions
} from "../../../shared/form/component/formFields/FormikSelect"
import AllTextState from "../../../shared/state/AllTextState"
import Toast from "../../../shared/ui/notification/Toast"
import {
  getCurrentUserId,
  getCurrentUserOrgId,
  getUserInfo,
  setUserPermission
} from "../../app/state/appSessionStorage"
import { useEffect, useState } from "react"
import { useChatContext } from "../../features/chat/state/context/ChatContext"
import { setCurrentChatId } from "../../features/chat/state/chatActions"
import SubmittingSpinner from "../../shared/SubmittingSpinner"

interface IProps {
  closeFunc: any;
  organizations: any;
}

const SwitchOrganizationModal = (props: IProps): JSX.Element => {
  const [organizationChanged, setOrganizationChanged] = useState<any>()
  const history = useHistory()
  const {dispatch, connect, disconnect} = useChatContext()

  useEffect(() => {
    if (organizationChanged) {
      const userTemp = getUserInfo()
      userTemp.currentOrgName = organizationChanged[0].label
      sessionStorage.setItem("userInfo", JSON.stringify(userTemp))
    }
  }, [organizationChanged])

  const orgOptions: TSelectFieldOptions = props.organizations.map(
    (key: any) => {
      return {
        value: key.orgId,
        label: key.orgName
      }
    }
  )

  const currentOrgInitial = {
    currentOrgId: getCurrentUserOrgId()
  }

  return (
    <>
      {AllTextState.switchOrganization}
      <div style={{ height: "250px",
        width: "300px" }}>
        <Formik
          enableReinitialize
          initialValues={currentOrgInitial}
          onSubmit={async (values, { setSubmitting })  => {
            // When button submits form and form is in the process of submitting, submit button is disabled
            setSubmitting(true)
            dispatch(setCurrentChatId(""))
            const switchOrg = async () => {
              axiosPrivate
                .get(`rest/switch_organization/${values.currentOrgId}`)
                .then((response: any) => {
                  if (response.status === 200) {
                    const organization = orgOptions.filter(
                      (org) => org.value === values.currentOrgId
                    )
                    setOrganizationChanged(organization)
                    setUserPermission(response.data)
                    disconnect()
                    connect(getCurrentUserId())
                    history.replace({
                      pathname: RoutePaths.DASHBOARD
                    })
                    Toast("Switched Club Successfully", "success")
                    props.closeFunc()
                    setSubmitting(false)
                  }
                })
                .catch((error) => {
                  console.error(error)
                  Toast("Failed To Switch Club", "error")
                  props.closeFunc()
                  setSubmitting(false)
                })
            }
            await switchOrg()
            // Sets setSubmitting to false after form is reset
          }}
        >
          {(formikProps: any): any => {
            return (
              <Form onSubmit={formikProps.handleSubmit}>
                <Row>
                  <Col md={12}>
                    <FormikSelect
                      title="currentOrgId"
                      options={orgOptions}
                      placeholderText="Select . . ."
                      formikProps={formikProps}
                    />
                  </Col>
                </Row>
                <Row className="justify-content-center m-t-20">
                  <Col md="auto">
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={!formikProps.dirty || formikProps.isSubmitting}
                    >
                      {formikProps.isSubmitting ? (
                        <SubmittingSpinner text="Submitting" />
                      ) : (
                        'Submit'
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            )
          }}
        </Formik>
      </div>
    </>
  )
}

export default SwitchOrganizationModal
